import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "emotionCommon" }
const _hoisted_2 = { class: "parameterCommon" }
const _hoisted_3 = { class: "topInputInner" }

import { ref, onMounted,getCurrentInstance } from 'vue'
import slider from '../commonPage/slider.vue'
import {
    Upload,
} from "@element-plus/icons-vue";
import Auth from "@/api/Auth";
import FetchRequest from "@/api/FetchRequest";
import { ElMessage, ElMessageBox, ElSwitch } from "element-plus";

export default /*@__PURE__*/_defineComponent({
  __name: 'emotionTxt',
  emits: ['referData'],
  setup(__props, { emit: __emit }) {

const token = Auth.getToken();
const emit = __emit
const textarea=ref('')
const updataNum=()=>{
    emit('emotxtData',textarea.value)
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "commonTitle" }, [
        _createElementVNode("span", null, " 情感描述文本")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          modelValue: textarea.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((textarea).value = $event)),
          maxlength: "5000",
          style: {"height":"100%"},
          placeholder: "请描述情感状态，例如：非常愤怒、歇斯底里、咆哮",
          type: "textarea",
          resize: "none",
          onChange: updataNum
        }, null, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})